module.exports = __webpack_public_path__ + "static/golf-7d287c121489a4cb27ed52b921e22042.jpg";